/* dev/js_src/js/shared/web_components/avatar_group.js */
import css_text from '/srv/www/htdocs/loc/app/styles/web_components/avatar_group.css';

export class YalwaAvatarGroup extends HTMLElement {
    constructor() {
       super();
       this.attachShadow({mode: 'open'});
       this.initialize_template();
       this.apply_css();
    }
    
    initialize_template() {
       this.shadowRoot.innerHTML = `
        <div class="avatar_group_container" part="container">
            <slot id="avatar-slot"></slot>
            <div class="more_counter" part="more" style="display:none;"></div>
        </div>
    `;
       this.counter = this.shadowRoot.querySelector('.more_counter');
       this.shadowRoot.getElementById('avatar-slot').addEventListener('slotchange', () => this.update_group());
    }
    
    /* dev/js_src/js/shared/web_components/avatar_group.js */

async apply_css() {
   await yalwa.basics.check_stylesheet_polyfill_needed();
   const sheet = new CSSStyleSheet();

   sheet.replaceSync(css_text + `

        .avatar_group_container[data-size="xs"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="xs"] .more_counter {
            margin-left: calc(var(--space_xs) * -1);
        }
        .avatar_group_container[data-size="sm"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="sm"] .more_counter {
            margin-left: calc(var(--space_sm) * -1);
        }
        .avatar_group_container[data-size="md"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="md"] .more_counter {
            margin-left: calc(var(--space_md) * -1);
        }
        .avatar_group_container[data-size="lg"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="lg"] .more_counter {
            margin-left: calc(var(--space_lg) * -1);
        }

        .avatar_group_container[data-size="xl"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="xl"] .more_counter {
            margin-left: calc(var(--space_xl) * -1);
        }

        .avatar_group_container[data-size="2xl"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="2xl"] .more_counter {
            margin-left: calc(var(--space_2xl) * -1);
        }

        .avatar_group_container[data-size="3xl"] ::slotted(yalwa-avatar),
        .avatar_group_container[data-size="3xl"] .more_counter {
            margin-left: calc(var(--space_3xl) * -1);
        }

        /* --- RESET: No margin for the first visible avatar --- */
        ::slotted(yalwa-avatar[data-first]) {
            margin-left: 0 !important;
        }
   `);
   
   this.shadowRoot.adoptedStyleSheets = [sheet];
   jQuery(this).removeClass('invisible');
}
    
    update_group() {
       const max = parseInt(this.getAttribute('max')) || 5;
       const size = this.getAttribute('size') || 'md';
       const avatars = this.querySelectorAll('yalwa-avatar');
       const overflow = avatars.length - max;
       
       // 1. Pass size to container for SCSS mapping
       const container = this.shadowRoot.querySelector('.avatar_group_container');
       container.setAttribute('data-size', size);
       
       // 2. Manage children
       let first_visible_set = false;
       avatars.forEach((avatar, index) => {
          const is_visible = index < max;
          avatar.style.display = is_visible ? '' : 'none';
          
          // Force children to match group size & look
          avatar.setAttribute('size', size);
          avatar.setAttribute('outside_border', '');

          // Logic to identify the first VISIBLE item (safe for margin reset)
          if (is_visible && !first_visible_set) {
              avatar.setAttribute('data-first', '');
              first_visible_set = true;
          } else {
              avatar.removeAttribute('data-first');
          }
       });
       
       // 3. Manage Counter
       if (overflow > 0) {
          this.counter.textContent = `+${overflow}`;
          this.counter.style.display = 'flex';
       } else {
          this.counter.style.display = 'none';
       }
    }
}

customElements.define('yalwa-avatar-group', YalwaAvatarGroup);